function Loading() {
  return <div>Add-In wird geladen...</div>;
}

export default Loading;
